import React from "react";
import CartCards from "./CartComponent/CartCards";
import DataService from "../../service/DataService";
import { useRestaurant } from "../../hooks/RestaurantContext";
import { useTheme } from "../../hooks/ThemeContext";
import { getRemoteEnv } from '../../config/remoteEnv';
import { loadOrderMeta, estimationRuleOf, type EstimationRule } from '../../service/OrderEta';
import OrderEtaLine from '../OrderEta/OrderEtaLine';


const OrderConfirmationPage = () => {

    const url = new URL(window.location.href);
    const orderId = url.searchParams.get('id');

    const [productData, setProductData] = React.useState({});
    const [cart, setCart] = React.useState({})
    // Estimated ready / arrival time: the checkout saved the order's timing
    // inputs locally (guests have no order history to read them from).
    const meta = React.useMemo(() => (orderId ? loadOrderMeta(orderId) : null), [orderId]);
    const [rule, setRule] = React.useState<EstimationRule | null>(null);
    React.useEffect(() => {
        const storeId = meta?.storeId || url.searchParams.get('r');
        if (!storeId) return;
        DataService.GetData("storeConfig", storeId).then((cfg: any) => setRule(estimationRuleOf(cfg))).catch(() => {});
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [meta]);

    const { restaurantId } = useRestaurant();

    const { theme } = useTheme();

    const setMenu = (e: any) => {
        setProductData(e.data.menu);
    }

    React.useEffect(() => {
        let cartData = localStorage.getItem(`order_${orderId}`);
        console.log("cartData: ", cartData)
        if (cartData) {
            setCart(JSON.parse(cartData));
        }
        console.log(JSON.stringify(cart))

    }, [orderId])

    React.useEffect(() => {
        if (restaurantId) {
            DataService.GetData("restaurants", restaurantId, undefined, setMenu).then((result) => {
                console.log("product data: ", result)
                console.log("cart: ", cart)
                setProductData(result.menu);
            });
        }

    }, [restaurantId])

    if (orderId && cart && productData) {
        return (
            <div style={{display: "flex", flexDirection: "column", alignItems: "center", padding: "20px"}}>
                
                <h2 style={{color: theme.textColor}}>Your order has been confirmed! Your order number is {orderId}</h2>
                {meta && (
                    <div style={{ marginBottom: "12px" }}>
                        <OrderEtaLine input={{ orderTime: meta.orderTime, orderType: meta.orderType, deliveryQuote: meta.deliveryQuote, rule }} color={theme.textColor} />
                    </div>
                )}

                {getRemoteEnv().currencySymbol && <div style={{width: "80%"}}>
                    <CartCards productData={productData} cart={cart} currencySymbol={getRemoteEnv().currencySymbol}/>               
                </div>}

            </div>
        )
    }
    else {
        return (
            <div>
                <h2>Error: Page not found</h2>
            </div>
        )
    }
}

export default OrderConfirmationPage;